var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F3F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13L13.4 13M15 21H25L29 13H13.4M15 21L13.4 13M15 21L12.7071 23.2929C12.0771 23.9229 12.5233 25 13.4142 25H25M25 25C23.8954 25 23 25.8954 23 27C23 28.1046 23.8954 29 25 29C26.1046 29 27 28.1046 27 27C27 25.8954 26.1046 25 25 25ZM17 27C17 28.1046 16.1046 29 15 29C13.8954 29 13 28.1046 13 27C13 25.8954 13.8954 25 15 25C16.1046 25 17 25.8954 17 27Z",
    stroke: "#0E0333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartCircle);
export default __webpack_public_path__ + "static/media/cart-circle.c4dde3ffe64d4e056dea26384a420c7f.svg";
export { ForwardRef as ReactComponent };